import type { Locale } from './context';

/** CLDR plural categories supported by the i18n layer. */
export type PluralCategory = 'zero' | 'one' | 'two' | 'few' | 'many' | 'other';

const pluralRulesCache = new Map<string, Intl.PluralRules>();

/**
 * Resolve the CLDR plural category for `value` in `locale` using
 * `Intl.PluralRules`. Falls back to a naive `one`/`other` split if the
 * runtime lacks `Intl.PluralRules` (extremely rare in modern browsers).
 */
export const getPluralCategory = (locale: Locale, value: number): PluralCategory => {
  try {
    let rules = pluralRulesCache.get(locale);
    if (!rules) {
      rules = new Intl.PluralRules(locale);
      pluralRulesCache.set(locale, rules);
    }
    return rules.select(value) as PluralCategory;
  } catch {
    return value === 1 ? 'one' : 'other';
  }
};